import { makeGet } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { Zona } from './zona';

export async function obtenerZonasActivas(): Promise<Envelope<Zona[]>> {
  const response = await makeGet<Zona[]>(`/zonas/activas`);
  return response;
}
